import type { FAQPage, Organization, WithContext, Question } from 'schema-dts';

interface FAQItem {
    title: string;
    text: string;
}

/**
 * Strip HTML and markdown formatting to plain text for schema.org
 */
function stripFormatting(text: string): string {
    return text
        .replace(/<[^>]*>/g, ' ') // HTML tags
        .replace(/\*\*(.+?)\*\*/g, '$1') // bold
        .replace(/\*(.+?)\*/g, '$1') // italic
        .replace(/__(.+?)__/g, '$1') // bold alt
        .replace(/_(.+?)_/g, '$1') // italic alt
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links
        .replace(/^#+\s*/gm, '') // headers
        .replace(/`([^`]+)`/g, '$1') // inline code
        .replace(/\s+/g, ' ') // collapse whitespace
        .trim();
}

export function generateFAQPageSchema(faqs: FAQItem[]): WithContext<FAQPage> {
    return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq): Question => ({
            '@type': 'Question',
            name: stripFormatting(faq.title),
            acceptedAnswer: {
                '@type': 'Answer',
                text: stripFormatting(faq.text),
            },
        })),
    };
}

export function generateOrganizationSchema(): WithContext<Organization> {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': 'https://www.muzology.com/#organization',
        name: 'Muzology',
        url: 'https://www.muzology.com',
        logo: 'https://www.muzology.com/logo.png',
        founder: {
            '@type': 'Person',
            name: 'Dr. Lana Israel',
        },
        sameAs: [
            'https://www.linkedin.com/company/muzology',
            'https://twitter.com/muzology',
            'https://www.instagram.com/muzology',
        ],
    };
}
